import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { selectReducedText, selectHideDecreasedPriceIcons, clearanceText, saleText, lowStockText } from '../store/orderingSlice';

function ColorDrawerAvailableVariantsItem({ variant }) {
	const reduced_text = useSelector(selectReducedText);
	const hide_decreased_price_icons = useSelector(selectHideDecreasedPriceIcons);
	const clearance_text = useSelector(clearanceText);
	const sale_text = useSelector(saleText);
	const low_stock_text = useSelector(lowStockText);

	let price_decreased_text = '';
	if (variant.reduced) {
		price_decreased_text = reduced_text;
	} else if (variant.closeout) {
		price_decreased_text = clearance_text;
	} else if (variant.sale) {
		price_decreased_text = sale_text;
	}
	const price_decreased_class_name = classNames({
		'color-drawer__size-icon--is-reduced': !hide_decreased_price_icons && variant.reduced,
		'color-drawer__size-icon--is-closeout': !hide_decreased_price_icons && !variant.reduced && variant.closeout,
		'color-drawer__size-icon--is-sale':
			!hide_decreased_price_icons && !variant.reduced && !variant.closeout && variant.sale,
	});

	const class_name = classNames({
		'color-drawer__size': true,
		'color-drawer__size--is-backordered': variant.backordered,
		'color-drawer__size--is-low-stock': variant.low_stock,
		'color-drawer__size--is-reduced': variant.reduced,
		'color-drawer__size--is-closeout': !variant.reduced && variant.closeout,
		'color-drawer__size--is-sale': !variant.reduced && !variant.closeout && variant.sale,
	});

	return (
		<li className={class_name}>
			{variant.label}
			{(variant.low_stock || price_decreased_text) && (
				<div className='color-drawer__size-icons'>
					{variant.low_stock && (
						<span
							className='color-drawer__size-icon color-drawer__size-icon--is-low-stock'
							title={low_stock_text}
							aria-label={low_stock_text}
							role="img"
						></span>
					)}
					{price_decreased_text && (
						<span
							className={`color-drawer__size-icon ${price_decreased_class_name}`}
							title={price_decreased_text}
							aria-label={price_decreased_text}
							role="img"
						></span>
					)}
				</div>
			)}
		</li>
	);
}

export function ColorDrawerAvailableVariants({ variants }) {
	const available_text = useSelector((state) => state.ordering.static_labels_object.AvailableIn)

	return (
		<>
			<div className='color-drawer__sizes-label'>{available_text}:</div>
			<ul className='color-drawer__sizes-list'>
				{variants.map((variant, index) => (
					<ColorDrawerAvailableVariantsItem key={index} variant={variant} />
				))}
			</ul>
		</>
	);
}
